import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
  MatTreeModule,
} from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
//import { JkGlbClass } from './jkglb';
import { AppPage } from './jkClass';
import { jkLib } from './jkCommon';

export interface PageNode {
  title: string;
  url?: string;
  icon?: string;
  id: string;
  isCheckPower?: boolean;
  checked?: boolean;
  //caption?: string;
  hint?: string;
  items?: PageNode[];
  level: number;
  expandable?: boolean;
}

/** Flat node with expandable and level information */
export interface ExampleFlatNode {
  expandable: boolean;
  title: string;
  level: number;
  id: string;
  /*title: string ;
  url?: string ;
  icon?: string;
  id: string;
  isCheckPower?: boolean ;
  checked?: boolean;
  caption?: string;
  hint?: string;
  items?: ExampleFlatNode;
  level: number ;
  expandable: boolean ;
  */
}

@Injectable({
  providedIn: 'root',
})
export class JkMenuService {
  /*get menuTree(): AppPages[] {

    return menuTree; //this._menuTree;
  }
  set menuTree(tree: AppPages[]) {
    this._menuTree = tree;
    if (this._menuTree[0] && this._menuTree[0].items)
      this.subMenu = this._menuTree[0].items;
  }*/
  router: Router = inject(Router);
  subMenu: AppPage[] = [];
  callProgramId: string = '';
  public showFirstSubmenuModes: any;
  public showSubmenuModes: any;
  TREE_DATA: PageNode[] = [];
  private _transformer = (node: PageNode, level: number) => {
    /*let n: PageNode = {id:'',title:'',url:'',icon:'',level:0,expandable:false};
    jkLib.cloneObject(node,n);
    n.level = level;
    n.expandable = !!node.items && node.items.length > 0;
    return n */
    return {
      expandable: !!node.items && node.items.length > 0,
      title: node.title,
      level: level,
      id: node.id,
      /*expandable: !!node.items && node.items.length > 0,
      caption: node.caption,
      level: level,
      items: node.items,
      url: node.url,
      id: node.id,
      title: node.title*/
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    //treeControl = new FlatTreeControl<AppPages>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.items
  );
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  constructor() {
    try {
      this.showSubmenuModes = [
        {
          name: 'onHover',
          delay: { show: 0, hide: 500 },
        },
        {
          name: 'onClick',
          delay: { show: 0, hide: 300 },
        },
      ];

      this.showFirstSubmenuModes = this.showSubmenuModes[1];
    } catch (error: any) {
      console.error('JkMenuService error:' + error);
    }
    this.init();
  }
  /*
  init(router: Router,pages:AppPages[],menuTree: AppPages[]) {
    this.router = router;
    this.menuTree = menuTree;
    if(this.menuTree[0]){
      if(this.menuTree[0].items){
        this.subMenu = this.menuTree[0].items;
      }
    }
    //this.appPages = pages;
    this.mergePageAndTree(pages, menuTree);
  }*/
  init() {
    if (this.TREE_DATA.length === 0) {
      //this.mergePageAndTree(this.pages, menuTree);
      //this.initDataTree(menuTree, this.TREE_DATA);
      this.dataSource.data = this.TREE_DATA;
    }
  }
  segmentClick(item: AppPage) {
    if (item.items) {
      //alert('segmentClick');
      this.subMenu = item.items;
    } else {
      this.router.navigate([item.url]);
    }
  }
  /*importAppPages(pages: AppPages[]) {
      this.appPages = pages;
      this.appTree = [];
      for (let i = 0; i < pages.length; i++) {
        let page = pages[i];
        if(page.url !== ''){
          page.title = page.title + '(' + page.id + ')';
        }
        let parent = this.searchTree(this.appTree,page);
        if (parent) {
          if(!parent.items){ parent.items = []; };
          parent.items.push(page);
        } else {
          this.appTree.push(page);
        };
      }
    }*/
  mergePageAndTree(pages: AppPage[], tree: AppPage[]) {
    if (!tree) return;
    if (!pages) return;
    //this.menuTree = tree;
    for (let i = 0; i < tree.length; i++) {
      let item = tree[i];
      let page = this.treeSearchById(pages, item.id);
      if (page) {// 真的找到. 不是空白
        //jkLib.cloneField(page,item);
        item.url = page.url;
        item.title = page.title;
        item.icon = page.icon;
        item.isCheckPower = page.isCheckPower;
        item.caption = page.title + '(' + page.id + ')';
      }
      if (item.items) {
        this.mergePageAndTree(pages, item.items);
      }
    }
  }
  /*
  searchTree(pageList: AppPages[], page: AppPages): AppPages {
    let result: AppPages = null;
    for (let i = 0; i < pageList.length; i++) {
      let item = pageList[i];
      if (item.id === page.parentId) {
        result = item;
        break;
      } else {
        if (item.items) {
          result = this.searchTree(item.items, page);
          if (result) {
            break;
          }
        }
      }
    }
    return result;
  }*/
  /**
   * 樹狀搜尋
   * @param pageList
   * @param id
   * @returns
   */
  treeSearchById(pageList: AppPage[], id: string): AppPage | undefined {
    let result: AppPage | undefined;
    if (!pageList) {
      alert('jkmenu.treeSearchById pageList is null');
      return undefined;
    }
    for (let i = 0; i < pageList.length; i++) {
      let item = pageList[i];
      if (item.id === id) {
        result = item;
        break;
      } else {
        if (item.items) {
          result = this.treeSearchById(item.items, id) || undefined;
          if (result) {
            break;
          }
        }
      }
    }
    return result;
  }
  menuClick(pages: AppPage[], data: any): boolean {
    if (!data.expandable) {
      let p = this.treeSearchById(pages, data.id);
      if (p) {
        if (!this.router) {
          alert('jkmenu.router 未設定');
          return false;
        }
        this.router.navigate([p.url]);
        return true;
      }
    }
    /*const item = data.itemData;
    let url = item.url;
    if (url) {
      this.navigateTo(url);
    }*/
    return false;
  }
  listClick(item: AppPage) {
    let url = item.url;
    if (url) {
      this.router.navigate([url]);
    }
  }
  doProgramId(pages: AppPage[]) {

    let p = this.treeSearchById(pages, this.callProgramId);
    if (p)
      this.router.navigate([p.url])
    else
      alert('找不到程式代號:' + this.callProgramId + '的程式');
  }
  initDataTree(pages: AppPage[], tree: PageNode[] | undefined) {
    if (!tree) return;
    if (!pages) return;
    //this.menuTree = tree;
    for (let i = 0; i < pages.length; i++) {
      let item = pages[i];
      let tNode: PageNode = {
        title: item.title,
        expandable: false,
        items: [],
        level: 0,
        checked: item.checked,
        icon: item.icon,
        id: item.id,
        isCheckPower: item.isCheckPower,
        url: jkLib.fixString(item.url),
        hint: item.hint,
      };
      if (item.items) {
        tNode.expandable = true;
      } else {
        tNode.title = item.title + '(' + item.id + ')';
      }
      tree.push(tNode);
      if (item.items) {
        this.initDataTree(item.items, tNode.items);
      }
    }
  }
}
